export default "__VITE_ASSET__JAeifGJJ__"